module.exports = __webpack_public_path__ + "img/btn_magazine_on.d354eb27.png";